// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__W24b5","tyre":"style_tyre__1LKQ+"};